import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  },
  {
    path: '/merchant/:id?',
    name: 'Merchant',
    component: () => import(/* webpackChunkName: "merchant" */ '@/views/Merchant.vue'),
    props: (route) => ({
      id: route.params.id
    })
  },
  {
    path: '/retailer/:id?',
    name: 'Retailer',
    component: () => import(/* webpackChunkName: "retailer" */ '@/views/Retailer.vue'),
    props: (route) => ({
      id: route.params.id
    })
  },
  {
    path: '/pretailer/:id?',
    name: 'Pretailer',
    component: () => import(/* webpackChunkName: "pretailer" */ '@/views/PRetailer.vue'),
    props: (route) => ({
      id: route.params.id
    })
  },
  {
    path: '/retailer/:id/pretailer/:pretailerId/store/:storeId/msgsearch',
    name: 'MSG Search',
    component: () => import(/* webpackChunkName: "msgsearch" */ '@/views/MSGSearch.vue'),
    props: (route) => ({
      id: route.params.id,
      pretailerId: route.params.pretailerId,
      storeId: route.params.storeId
    })
  },
  {
    path: '/retailer/:id/sitefilter',
    name: 'Site Filter',
    component: () => import(/* webpackChunkName: "sitefilter" */ '@/views/SiteFilter.vue'),   
    props: (route) => ({
      id: route.params.id
    })
  },
  {
    path: '/retailer/:id/site/:siteid',
    name: 'Site',
    component: () => import(/* webpackChunkName: "site" */ '@/views/Site.vue'),   
    props: (route) => ({
      id: route.params.id,
      siteid: route.params.siteid
    })
  },
  {
    path: '/retailer/:id/promotiongroups',
    name: 'Promotion Groups',
    component: () => import(/* webpackChunkName: "promotiongroups" */ '@/views/PromotionGroups.vue'),   
    props: (route) => ({
      id: route.params.id,
    })
  },
  {
    path: '/retailer/:id/retailertags',
    name: 'Retailer Tags',
    component: () => import(/* webpackChunkName: "retailertag" */ '@/views/RetailerTag.vue'),   
    props: (route) => ({
      id: route.params.id,
    })
  },
  {
    path: '/profanitymanager',
    name: 'Profanity Manager',
    component: () => import(/* webpackChunkName: "profanitymanager" */ '@/views/ProfanityManager.vue'),
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: () => import(/* webpackChunkName: "campaigns" */ '@/views/Campaigns.vue'),
  },
  {
    path: '/sitegroupsearch',
    name: 'Site Group Search',
    component: () => import(/* webpackChunkName: "sitegroupsearch" */ '@/views/SiteGroupSearch.vue'),
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if( to.fullPath != '/' && !store.getters['user/loggedIn']) {
    next({ path: '/'})
  }
  next()
})

export default router
